export default __webpack_public_path__ + "static/media/Monger-HUD-Pop-Up (Target Lock).39ca97df.jpg";